/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

import {channel_type_style} from 'hiya-common/src/reducers/commonTypes'
import {
  channel_type_enum,
  getCountyIndexMap,
  IdentityTypeEnum,
  vcode_channel,
} from './constant'
import {
  config_item,
  paybindst,
  signauthst,
  channel_item,
  ThirdPayItem,
  CashInfo,
  pay_bind_kind_enum,
} from './interface'

// 签约及支付绑定相关配置 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92446972
export const pay_cfg = createAsyncThunk(
  'TalentsCenter_pay_cfg',
  async (arg: any, store: any) => {
    // 默认获取的是身份认证的 各个页面之前的数据基本互相独立 无需外部传参了
    const {channel_type} = store.getState().TalentsGatherInfo
    const resp = await http.post<
      HiyaRes<
        Pick<InitialStateType, 'list' | 'own_country_code' | 'dur_set_time'> & {
          third_list?: ThirdPayItem[]
          style_list?: channel_type_style[]
        }
      >
    >(
      '/live/facetime/pay_cfg',
      {
        channel_type,
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 拉取一次列表用于刷新账号的绑定状态(目前主要针对payonner) http://wiki.xunlei.cn/pages/viewpage.action?pageId=92447647
export const refreshStatus = createAsyncThunk(
  'TalentsCenter_refreshPayoneerStatus',
  async (
    arg: {
      id: string
      from?: string
      channel_type?: any
      need_pass?: boolean
      isPureRefresh?: boolean // 如果只是单纯的刷新 就只调用/live/facetime/sync_bind 不调用查询数据的
    },
    store: any
  ) => {
    const {h_m: mid} = store.getState().env.deviceinfo
    const {channel_type} = store.getState().TalentsGatherInfo
    const sleep = (s) => {
      return new Promise((res) => {
        setTimeout(() => {
          res(null)
        }, s)
      })
    }
    let resp = null
    // 刷新绑定状态 http://wiki.xunlei.cn/pages/viewpage.action?pageId=113923361
    resp = await http.post('/live/facetime/sync_bind', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    sleep(2000)
    // 非纯刷新的时候，才去调取绑定信息
    if (!arg.isPureRefresh) {
      resp = await http.post<
        HiyaRes<Pick<InitialStateType, 'list' | 'sign_info'>>
      >(
        '/live/facetime/pay_bind_list_by_mid',
        {
          ...store.getState().env.deviceinfo,
          mid,
          channel_type,
          ...arg,
        },
        {
          xcErrorToast: true,
        }
      )
    }

    return resp.data.data
  }
)

// 删除绑定数据 http://wiki.xunlei.cn/pages/viewpage.action?pageId=113926936
export const del_archive_pay_bind = createAsyncThunk(
  'facetime_/live/facetime/del_archive_pay_bind',
  async (arg: {id: string}, store: any) => {
    const resp = await http.post(
      '/live/facetime/del_archive_pay_bind',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 删除绑定数据 http://wiki.xunlei.cn/pages/viewpage.action?pageId=117037131
export const gen_payoneer_share_link = createAsyncThunk(
  'facetime_/live/facetime/gen_payoneer_share_link',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string // 错误信息 比如没有钱
        register_url: string // 注册链接
      }>
    >(
      '/live/facetime/gen_payoneer_share_link',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 放弃 已经生成的payonner分享链接 http://wiki.xunlei.cn/pages/viewpage.action?pageId=117037140
export const abandon_payoneer_share_link = createAsyncThunk(
  'facetime_/live/facetime/abandon_payoneer_share_link',
  async (arg: {id: string}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string // 错误信息 比如没有钱
        register_url: string // 注册链接
      }>
    >(
      '/live/facetime/abandon_payoneer_share_link',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 根据mid获取支付绑定和认证信息列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92447647
// need_pass 选择通过/都选
export const pay_bind_list_by_mid = createAsyncThunk(
  'TalentsCenter_pay_bind_list_by_mid',
  async (arg: {channel_type?: any; need_pass?: boolean}, store: any) => {
    const {h_m: mid} = store.getState().env.deviceinfo
    const {channel_type} = store.getState().TalentsGatherInfo
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'list' | 'sign_info'>>
    >('/live/facetime/pay_bind_list_by_mid', {
      mid,
      channel_type,
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 主播身份认证（包括公会主） http://wiki.xunlei.cn/pages/viewpage.action?pageId=92446886
export const sign_auth = createAsyncThunk(
  'facetime_sign_auth',
  async (
    arg: {
      country: number
      real_name: string
      identity_document: IdentityTypeEnum
      identity_document_number: string
      identity_document_photo: string
      identity_document_sample: string
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/facetime/sign_auth',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 支付绑定 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92447472
export const pay_bind = createAsyncThunk(
  'facetime_pay_bind',
  async (
    arg: {
      [key: string]: any
      channel_type?: channel_type_enum
      kind?: number // kind 必须（payonner需要） 0:原来的 1:直接走绑定流程
      // 第三方支付信息收集增加的参数
      phone_region?: string
      phone?: string
      ucode?: string // 校验身份后获得的
    },
    store: any
  ) => {
    const {channel_type} = store.getState().TalentsGatherInfo
    const resp = await http.post<
      HiyaRes<{err_msg: string; register_url?: string}>
    >(
      '/live/facetime/pay_bind',
      {
        channel_type,
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 修改默认的支付方式 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92447654
export const update_default_pay = createAsyncThunk(
  'facetime_update_default_pay',
  async (arg: {channel_type: channel_type_enum; id: string}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/facetime/update_default_pay',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取验证渠道信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100404339
export const union_get_verify_channel = createAsyncThunk(
  'TalentsGatherInfo/live/account/get_verify_channel',
  async (arg: {region_code: number}, store: any) => {
    const resp = await http.post(
      '/live/account/get_verify_channel',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取验证码 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90610202
export const union_get_vcode = createAsyncThunk(
  'TalentsGatherInfo/live/account/get_vcode',
  async (
    arg: {channel: number; phone?: string; region_code: string},
    store: any
  ) => {
    const resp = await http.post(
      '/live/account/get_vcode',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
        kind: 'verify_pay_bind', // 支付绑定专用
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 通过邮箱获取验证码  http://wiki.xunlei.cn/pages/viewpage.action?pageId=127593899
export const union_get_code_by_email = createAsyncThunk(
  'TalentsGatherInfo/live/union/get_code_by_email',
  async (arg: {payee_email: string}, store: any) => {
    const resp = await http.post(
      '/live/account/get_code_by_email',
      {
        ...store.getState().env.deviceinfo,
        email: arg.payee_email,
        kind: 'verify_pay_bind', // 支付绑定专用
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 校验身份 判断验证码是否生效 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90607675
export const union_verify_identity = createAsyncThunk(
  'TalentsGatherInfo/live/account/verify_identity',
  async (
    arg: {
      phone: string
      vcode: string
      region_code: string
      channel: vcode_channel
    },
    store: any
  ) => {
    const {thirdParty} = store.getState().TalentsGatherInfo
    const resp = await http.post<HiyaRes<{ucode: string}>>(
      '/live/account/verify_identity',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
        kind:
          {
            0: 10, // 手机验证码
            1: 20, // 手机语音验证
            2: 21, // whatsapp验证
          }[arg.channel] || 0,
        source: 2, // 支付自动绑定使用
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 校验email 验证码 http://wiki.xunlei.cn/pages/viewpage.action?pageId=127593934
export const union_verify_email_code = createAsyncThunk(
  'TalentsGatherInfo/live/account/verify_email_code',
  async (
    arg: {
      payee_email: string
      vcode: string
    },
    store: any
  ) => {
    const {thirdParty} = store.getState().UnionGatherInfo
    const resp = await http.post<HiyaRes<{ucode: string}>>(
      '/live/account/verify_email_code',
      {
        ...store.getState().env.deviceinfo,
        email: arg.payee_email,
        code: arg.vcode,
        kind: 'verify_pay_bind',
        mid: store.getState().env.deviceinfo.h_m,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
interface InitialStateType {
  channel_type?: channel_type_enum
  // 默认配置相关
  list?: Array<config_item>
  own_country_code?: number
  dur_set_time?: boolean
  // 支付信息相关
  sign_info?: signauthst
  // 绑定的相关信息
  bind_list?: Array<paybindst>
  // 对应的渠道的绑定的信息
  bind_info?: paybindst
  union_info?: any
  // 第三方支付相关数据
  thirdParty?: {
    channel?: 0 | 1 | 2 // 获取验证码的渠道 0短信 1语音 2WhatsApp
  }
  // 20230628 所有config的数据都储存在pay_cfg 前面的展开了的就先展开做兼容
  pay_cfg?: {
    third_list?: ThirdPayItem[]
    cur_third?: ThirdPayItem // 当前第三方的数据配置
    style_list?: channel_type_style[]
    cur_style?: channel_type_style
    thirds?: channel_type_enum[] // 支持第三方支付的类型，都是验证码直接绑定免审核的类型
    // 线下支付需要数据
    cash_info: CashInfo
  }
}

const initialState: InitialStateType = {
  dur_set_time: true,
  union_info: {},
  thirdParty: {},
}

export const TalentsGatherInfoSlice = createSlice({
  name: 'TalentsGatherInfo',
  initialState,
  reducers: {
    resetPayonnerBindInfo: (state) => {
      Object.assign(state, {
        bind_info: {
          ...state.bind_info,
          id: null,
          payee_name: '',
          payee_email: '',
          channel_account: '',
        },
      })
    },
    setChannelType: (state, action: PayloadAction<channel_type_enum>) => {
      Object.assign(state, {
        channel_type: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(pay_cfg.fulfilled, (state, action) => {
      const {list = []} = action.payload
      Object.assign(state, action.payload, {list})
      Object.assign(state, {
        pay_cfg: {
          ...action.payload,
          list,
          cur_third: {
            ...action.payload?.third_list?.find(
              (item) => item.channel_type === state.channel_type
            ),
            need_channel_country: [channel_type_enum.USDTTRC20].some(
              (c) => c === state.channel_type
            ),
          },
          cur_style: action.payload?.style_list?.find(
            (item) => item.channel_type === state.channel_type
          ),
        },
      })
    })
    builder.addCase(pay_bind_list_by_mid.fulfilled, (state, action) => {
      const {list: bind_list = [], sign_info} = action.payload
      const {list = [], own_country_code, channel_type} = state
      if (channel_type === channel_type_enum.Identity) {
        // 处理页面所需数据
        if (!sign_info?.id) {
          // 获得默认的选项
          sign_info.submit_country = list?.some(
            (v) => v.country_code === own_country_code
          )
            ? own_country_code
            : list[0]?.country_code || 0
          sign_info.identity_document = list?.some(
            (v) => v.country_code === own_country_code
          )
            ? list?.find((v) => v.country_code === own_country_code).kv_list[0]
                .value
            : list[0]?.kv_list[0].value
        }
        sign_info.country_index = getCountyIndexMap(list || [])
        Object.assign(state, {bind_list, sign_info})
        return
      }
      // 针对支付信息绑定
      let bind_info: any = {}
      if (bind_list.some((b) => b.channel_type === channel_type)) {
        bind_info = bind_list.find((b) => b.channel_type === channel_type)
      }
      // Payoneer 专用
      if (channel_type === channel_type_enum.Payoneer) {
        bind_info.common_sample_list =
          list?.find((l) => l.channel_type === channel_type)
            .common_sample_list || []
        bind_info.channel_sample =
          bind_info.common_sample_list?.length &&
          bind_info.common_sample_list[2]
            ? bind_info.common_sample_list[2]
            : ''
      }
      // PayerMaxGCash 专用
      if (channel_type === channel_type_enum.GCash) {
        bind_info.common_sample_list =
          list?.find((l) => l.channel_type === channel_type)
            .common_sample_list || []
        bind_info.channel_sample =
          bind_info.common_sample_list?.length &&
          bind_info.common_sample_list[0]
            ? bind_info.common_sample_list[0]
            : ''
      }
      // if (channel_type === channel_type_enum.PayerMaxBank) {
      // 处理页面所需数据
      if (!bind_info?.id && list?.length) {
        // 获得默认的选项
        bind_info.channel_country = list?.some(
          (v) => v.country_code === own_country_code
        )
          ? own_country_code
          : list[0]?.country_code || 0
        bind_info.payee_country = list?.some(
          (v) => v.country_code === own_country_code
        )
          ? own_country_code
          : list[0]?.country_code || 0

        // bank code 在某些国家不是必选项目 暂时置空
        // bind_info.channel_code = list?.some(
        //   (v) => v.country_code === own_country_code
        // )
        //   ? list?.find((v) => v.country_code === own_country_code).kv_list[0]
        //       .value
        //   : list[0]?.kv_list[0].value

        if (channel_type === channel_type_enum.AirWallexBank) {
          // bind_info.channel_bic_swift = list?.some(
          //   (v) => v.country_code === own_country_code
          // )
          //   ? list?.find((v) => v.country_code === own_country_code).kv_list[0]
          //       .value
          //   : list[0]?.kv_list[0].value
          // bind_info.channel_bic_swift_sub = list?.some(
          //   (v) => v.country_code === own_country_code
          // )
          //   ? list?.find((v) => v.country_code === own_country_code).kv_list[0]
          //       .value
          //   : list[0]?.kv_list[0].value
        }
      }
      bind_info.country_index = getCountyIndexMap(list || [])
      // }
      Object.assign(state, {
        bind_list,
        sign_info,
        bind_info,
      })
    })
    builder.addCase(union_get_verify_channel.fulfilled, (state, action) => {
      Object.assign(state.thirdParty, {
        channel: action.payload?.list?.find(
          (item: channel_item) => item.is_show
        )?.channel,
      })
    })
  },
})
export default TalentsGatherInfoSlice.reducer
export const TalentsGatherInfoActions = TalentsGatherInfoSlice.actions
